// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"199":"c9b09033","202":"7a5ebe8b","445":"2b982445","453":"a0919e61","461":"626962c3","739":"82a50894"}[chunkId] + ".chunk.js";
};